import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/logo.png';

// Nalozi (kreiranje/izmena naloga) je JEDINA adminOnly stavka - sestra ima pristup
// svemu ostalom (poklapa se sa SecurityConfig: /api/users/** je jedini hasRole("ADMIN")).
const NAV_ITEMS = [
    { to: '/dashboard', label: 'Početna' },
    { to: '/group-scheduling', label: 'Zakazivanje termina' },
    { to: '/sveska', label: 'Sveska' },
    { to: '/patients', label: 'Pacijenti' },
    { to: '/settings', label: 'Podešavanja' },
    { to: '/reminders', label: 'Podsetnici' },
    { to: '/sms-log', label: 'SMS Istorija' },
    { to: '/users', label: 'Nalozi', adminOnly: true }
];

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = () => {
        sessionStorage.clear(); // Briše token i podatke o korisniku
        navigate('/login');
    };

    const closeMenu = () => setMenuOpen(false);

    // Ako korisnik nije ulogovan, ne prikazujemo meni
    if (!sessionStorage.getItem('token')) return null;

    const isAdmin = user?.roles === 'ADMIN';
    const visibleNavItems = NAV_ITEMS.filter(item => !item.adminOnly || isAdmin);

    return (
        <nav style={styles.nav}>
            <Link to="/dashboard" style={styles.logoLink} onClick={closeMenu}>
                <img src={logo} alt="Acu Slim Medica" style={styles.logoImg} />
                <span style={styles.logoText}>Acu Slim Medica</span>
            </Link>

            <ul className={`navbar-links${menuOpen ? ' navbar-links-open' : ''}`}>
                {visibleNavItems.map(item => (
                    <li key={item.to}>
                        <Link
                            to={item.to}
                            style={{
                                ...styles.link,
                                ...(location.pathname === item.to ? styles.linkActive : {})
                            }}
                            onClick={closeMenu}
                        >
                            {item.label}
                        </Link>
                    </li>
                ))}
                <li className="navbar-mobile-only">
                    <Link to="/account" style={styles.link} onClick={closeMenu}>Moj nalog</Link>
                </li>
                <li className="navbar-mobile-only">
                    <button onClick={() => { closeMenu(); handleLogout(); }} style={styles.logoutBtnMobile}>
                        Odjavi se
                    </button>
                </li>
            </ul>

            <div style={styles.userInfo}>
                <Link to="/account" className="navbar-username" style={styles.username} title="Moj nalog">👤 {user?.username}</Link>
                <button onClick={handleLogout} style={styles.logoutBtn} className="navbar-desktop-only">Odjavi se</button>
                <button
                    className="navbar-toggle"
                    style={styles.toggleBtn}
                    onClick={() => setMenuOpen(!menuOpen)}
                    aria-label="Meni"
                >
                    {menuOpen ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>
        </nav>
    );
};

const styles = {
    nav: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 20px',
        backgroundColor: '#1f2937',
        color: 'white',
        height: '60px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
    },
    logoLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        textDecoration: 'none',
        color: 'white',
        flexShrink: 0,
    },
    logoImg: { height: '36px', width: '36px', objectFit: 'contain' },
    logoText: { fontSize: '18px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    link: {
        color: 'white',
        textDecoration: 'none',
        fontWeight: '500',
    },
    linkActive: {
        color: '#38bdf8',
    },
    userInfo: { display: 'flex', alignItems: 'center', gap: '15px' },
    username: { fontSize: '14px', fontStyle: 'italic', color: 'white', textDecoration: 'none', cursor: 'pointer' },
    logoutBtn: {
        backgroundColor: '#e74c3c',
        color: 'white',
        border: 'none',
        padding: '5px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    logoutBtnMobile: {
        backgroundColor: '#e74c3c',
        color: 'white',
        border: 'none',
        padding: '10px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        width: '100%',
        marginTop: '8px',
        fontSize: '14px',
    },
    toggleBtn: {
        background: 'none',
        border: 'none',
        color: 'white',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px',
    }
};

export default Navbar;
